import { Provider } from '@angular/core';
import { RuntimeConfigService } from '@app/service/runtime-config.service';
import { DATADOG_CONFIG_TOKEN, DatadogService, buildDatadogConfig } from '@cudirect/sawdust/datadog';

export const provideDatadog = (): Provider[] => [
  {
    provide: DATADOG_CONFIG_TOKEN,
    useFactory: (appConfig: RuntimeConfigService) => {
      const config = appConfig.getConfig;
      return buildDatadogConfig(config?.dataDog);
    },
    deps: [RuntimeConfigService]
  },
  {
    provide: DatadogService,
    useFactory: (config: ReturnType<typeof buildDatadogConfig>) => {
      const datadog = new DatadogService();
      datadog.init(config);
      return datadog;
    },
    deps: [DATADOG_CONFIG_TOKEN]
  }
];
